import { TrunkatedAddress } from "@bkry/bowline-components/Utils";
import { getRaffleRegistrationAttributes } from "@bkry/bowline-redux/raffleRegistrations";
import { useWeb3React } from "@web3-react/core";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";

/**
 * RaffleWinnerRow
 */
const RaffleWinnerRow = (props, context) => {
  const { account } = useWeb3React();
  const { raffleRegistrationId } = props;
  const raffleRegistrationData = useSelector((state) =>
    getRaffleRegistrationAttributes(state, raffleRegistrationId)
  );

  const isCurrentUser = raffleRegistrationData?.wallet_address === account;

  return (
    <tr>
      <td className="text-end">{raffleRegistrationData?.position}</td>
      <td>
        <TrunkatedAddress address={raffleRegistrationData?.wallet_address} />
      </td>
      <td className="text-nowrap">
        {isCurrentUser && <span>{context.t("Your Wallet")}</span>}
      </td>
    </tr>
  );
};

/**  define proptype for the 'translation' function  */
RaffleWinnerRow.contextTypes = {
  t: PropTypes.func,
};

RaffleWinnerRow.propTypes = {
  raffleRegistrationId: PropTypes.string.isRequired,
};

/** export the component as redux connected component */
export default RaffleWinnerRow;
